$(document).ready(function() {
    function updateBundleNav(currentStep){
        if(currentStep <= 1){
            $('.bundle-prev').addClass('disabled');
        }else{
            $('.bundle-prev').removeClass('disabled');
        }
        if(currentStep >= 4){
            $('.bundle-next').addClass('disabled');
        }else{
            $('.bundle-next').removeClass('disabled');
        }
    }
    $(document).on('click', '.bundle-step:not(.disabled)', function() {
        const dataStep = parseInt($(this).data('step'));
        $('.bundle-step').removeClass('active passed');
        $(this).addClass('active').removeClass('passed');
        $(`.bundle-step-page[data-step="${dataStep}"]`).addClass('active').siblings().removeClass('active');
        for(let i = 1; i < dataStep; i++) {
            $(`.bundle-step[data-step="${i}"]`).addClass('passed');
        }
        updateBundleNav(dataStep);
    });
    $(document).on('click', '.bundle-next', function() {
        const currentStep = parseInt($('.bundle-step.active').data('step'));
        let nextStep = currentStep + 1;
        if(nextStep >= 4){
            nextStep = 4;
        }
        if(nextStep === 4) {
            $(this).addClass('disabled');
        }else{
            $(this).removeClass('disabled');
        }
        updateBundleNav(nextStep);
        $(`.bundle-step[data-step=${nextStep}]`).trigger('click');
    });
    $(document).on('click', '.bundle-prev', function() {
        const currentStep = parseInt($('.bundle-step.active').data('step'));
        let prevStep = currentStep - 1;
        if(prevStep <= 1){
            prevStep = 1;
        }
        if(prevStep === 1) {
            $(this).addClass('disabled');
        }else{
            $(this).removeClass('disabled');
        }
        updateBundleNav(prevStep);
        $(`.bundle-step[data-step=${prevStep}]`).trigger('click');
    });

    $(document).on('click','.quickbuy-bundle-toggle', function(e) {
        e.preventDefault();
        const sidebar = $(`.sidebar-main[data-sidebar-id="bundle-sidebar"]`);
        const productURL = $(this).attr('data-url');
        sidebar.addClass('expanded');
        $('body').addClass('overflow-hidden');

        $.ajax({
            url: productURL,
            type: 'GET',
            success: function(data) { 
                const content = $(data).html();
                sidebar.find('.sidebar-content').html(content);
            }
        });

    });


  $(document).on('click','.bundle-sidebar .option-cell.has-value',function(){
    $(this).addClass('selected');
    $(this).parents('.table-body').find('.option-cell').not($(this)[0]).removeClass('selected');
    let isDisabled = false;
    $('.bundle-sidebar .selector-wrapper').each(function(){
        if($(this).find('.option-cell.selected').length === 0){
            isDisabled = true;
            return false;
        }
    });
    console.log(isDisabled);
    if(isDisabled){
        $('.bundle-sidebar .sidebar-atc').attr('disabled','disabled');
    }else{
        $('.bundle-sidebar .sidebar-atc').removeAttr('disabled');
    }
  });

  $(document).on('click','.bundle-sidebar .sidebar-atc',function(){
    let variantTitle = '';
    let count = 0;
    $('.bundle-sidebar .option-cell.selected').each(function(){
        if(count > 0){
            variantTitle += ' / ';
        }
        variantTitle += $(this).data('value');
    });

    $('.variants-list span').each(function(){
        if($(this).text() === variantTitle){
            
        }
    });



  });

});